import { render, staticRenderFns } from "./registrations-change-password.vue?vue&type=template&id=ca1c352c"
import script from "./registrations-change-password.vue?vue&type=script&lang=js"
export * from "./registrations-change-password.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports